module.exports = __webpack_public_path__ + "img/kimmy_mobile.e4f43a3.jpg";